var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-docx-file-format';
                    var viewUrl = 'gfx/sprite.svg#view-icon-docx-file-format';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 548.291 548.291',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };